module.exports = __webpack_public_path__ + "fonts/iconfont.39f9814b.woff";